import VASTError from '@lib/iab/iab-vast-errors';

export class VASTLoaderError extends VASTError {
    public cause: Error | null;
    public uri: string | null;
    public $type: string;

    constructor(
        code: number,
        cause: Error | null = null,
        uri: string | null = null
    ) {
        super(code);
        this.cause = cause;
        this.uri = uri;
        this.$type = 'VASTLoaderError';
    }
}
